import { render } from "./fzhs.vue?vue&type=template&id=3d064181&scoped=true"
import script from "./fzhs.vue?vue&type=script&lang=js"
export * from "./fzhs.vue?vue&type=script&lang=js"

import "./fzhs.vue?vue&type=style&index=0&id=3d064181&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d064181"]])

export default __exports__